import { SHOW_HIDE_TOAST, UNREAD_NOTIFICATIONS, ALL_NOTIFICATIONS } from "./type";

const initialState = {
  isToast: false,
  toastMessage: "",
  unreadNotifications: [],
  allNotifications: [],
};

const toastReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SHOW_HIDE_TOAST:
      return {
        isToast: payload && payload.isToast,
        toastMessage: payload && payload.toastMessage,
      };

    case UNREAD_NOTIFICATIONS:
      return {
        ...state,
        unreadNotifications: payload,
      };

    case ALL_NOTIFICATIONS:
      return {
        ...state,
        allNotifications: payload,
      };
    default:
      return state;
  }
};
export default toastReducer;
